import {
  Button,
  Card,
  Col,
  Input,
  Row,
  Select,
  Table,
  DatePicker,
  message,
  Radio,
  Spin,
  Modal,
  Form,
} from "antd";
import { Component } from "react";
import moment from "moment";
import locale from "./../../constants/locale.json";
import "./CardLog.css";
const { Option } = Select;

const flexColumnOverflow = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
  overflowY: "scroll",
};
const flexColumn = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
};
const columns = [
  {
    title: "Date",
    dataIndex: "inserted_at",
    align: "center",
    render: (inserted_at) => {
      return <>{moment(inserted_at).format("DD/MM/YYYY HH:mm")}</>;
    },
    sorter: (a, b) =>
      moment(a.inserted_at).unix() - moment(b.inserted_at).unix(),
  },
  {
    title: "Access Type",
    dataIndex: "access_type_display_name",
    align: "center",
    sorter: (a, b) =>
      (a.access_type_display_name || "").localeCompare(
        b.access_type_display_name || ""
      ),
  },
  {
    title: "Gate",
    dataIndex: "gate_display_name",
    align: "center",
    render: (gate_display_name) => {
      return <>{!gate_display_name ? "-" : gate_display_name}</>;
    },
    sorter: (a, b) =>
      (a.gate_display_name || "").localeCompare(b.gate_display_name || ""),
  },
  {
    title: "Card UID",
    dataIndex: "uid",
    align: "center",
    sorter: (a, b) => (a.uid || "").localeCompare(b.uid || ""),
  },
  {
    title: "Card Label",
    dataIndex: "card_label",
    ellipsis: true,
    align: "center",
    render: (card_label) => {
      return <>{!card_label ? "-" : card_label}</>;
    },
    sorter: (a, b) => (a.card_label || "").localeCompare(b.card_label || ""),
  },
  {
    title: "First Name",
    dataIndex: "first_name",
    ellipsis: true,
    align: "center",
    render: (first_name) => {
      return <>{!first_name ? "-" : first_name}</>;
    },
    sorter: (a, b) => (a.first_name || "").localeCompare(b.first_name || ""),
  },
  {
    title: "Last Name",
    dataIndex: "last_name",
    ellipsis: true,
    align: "center",
    render: (last_name) => {
      return <>{!last_name ? "-" : last_name}</>;
    },
    sorter: (a, b) => (a.last_name || "").localeCompare(b.last_name || ""),
  },
  {
    title: "Shop",
    dataIndex: "shop_name",
    ellipsis: true,
    align: "center",
    render: (shop_name) => {
      return <>{!shop_name ? "-" : shop_name}</>;
    },
    sorter: (a, b) => (a.shop_name || "").localeCompare(b.shop_name || ""),
  },
  {
    title: "Position",
    dataIndex: "position",
    ellipsis: true,
    align: "center",
    render: (position) => {
      return <>{!position ? "-" : position}</>;
    },
    sorter: (a, b) => (a.position || "").localeCompare(b.position || ""),
  },
  {
    title: "License No.",
    dataIndex: "license_no",
    ellipsis: true,
    align: "center",
    render: (license_no) => {
      return <>{!license_no ? "-" : license_no}</>;
    },
    sorter: (a, b) => (a.license_no || "").localeCompare(b.license_no || ""),
  },
  {
    title: "Phone No.",
    dataIndex: "phone_number",
    ellipsis: true,
    align: "center",
    render: (phone_number) => {
      return <>{!phone_number ? "-" : phone_number}</>;
    },
    sorter: (a, b) =>
      (a.phone_number || "").localeCompare(b.phone_number || ""),
  },
  {
    title: "Processed By",
    dataIndex: "username",
    align: "center",
    render: (username) => {
      return <>{!username ? "-" : username}</>;
    },
    sorter: (a, b) => (a.username || "").localeCompare(b.username || ""),
  },
];

const options = [
  { label: "PDF", value: "pdf" },
  { label: "Excel", value: "xlsx" },
];

export default class CardLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: [],
      exportType: null,
      isExportModalVisible: false,
      isLoading: false,
      filterDateTimeStart: null,
      filterDateTimeEnd: null,
      filterCardUID: null,
      filterUserName: null,
      filterGateIds: [],
      filterAccessTypeIds: [],
      gates: [],
      accessTypes: [],
      exportDateStart: null,
      exportDateEnd: null,
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    fetch(`/api/v1/report/card/bundle`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        token: this.props.accessToken,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then((data) => {
        const { gates, accessTypes } = data;
        this.setState({
          gates,
          accessTypes,
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  }

  onInputFieldChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      logs: [],
      [name]: value,
    });
  };

  onFieldChange = (name, value) => {
    this.setState({
      logs: [],
      [name]: value,
    });
  };

  onSearchClick = () => {
    const { accessToken } = this.props;
    const {
      filterDateTimeStart,
      filterDateTimeEnd,
      filterCardUID,
      filterUserName,
      filterGateIds,
      filterAccessTypeIds,
    } = this.state;
    this.setState({
      logs: [],
      isLoading: true,
    });
    return fetch(`/api/v1/report/card/list`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: accessToken,
      },
      body: JSON.stringify({
        filterDateTimeStart,
        filterDateTimeEnd,
        filterCardUID,
        filterUserName,
        filterGateIds,
        filterAccessTypeIds,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then((data) => {
        const { logs } = data;
        if (logs.length === 0) {
          message.warning("No logs returned!");
        }
        return this.setState({
          logs,
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  onClearClick = () => {
    this.setState({
      logs: [],
      filterDateTimeStart: null,
      filterDateTimeEnd: null,
      filterCardUID: null,
      filterUserName: null,
      filterGateIds: [],
      filterAccessTypeIds: [],
    });
  };

  isFiltered = () => {
    const {
      filterDateTimeStart,
      filterDateTimeEnd,
      filterCardUID,
      filterUserName,
      filterGateIds,
      filterAccessTypeIds,
    } = this.state;
    return (
      !!filterDateTimeStart ||
      !!filterDateTimeEnd ||
      !!filterCardUID ||
      !!filterUserName ||
      (!!filterGateIds && filterGateIds.length > 0) ||
      (!!filterAccessTypeIds && filterAccessTypeIds.length > 0)
    );
  };

  getReport = (reportType) => {
    const { accessToken } = this.props;
    const { exportDateStart, exportDateEnd } = this.state;

    this.setState({
      isLoading: true,
    });
    fetch(`/api/v1/report/card/download/${reportType}`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: accessToken,
      },
      body: JSON.stringify({
        startDate: exportDateStart,
        endDate: exportDateEnd,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.blob();
      })
      .then((blob) => {
        const filename = moment(new Date()).format("YYYYMMDDHHmmss");
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}_CardLogReport.${reportType}`;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
        message.success("Card Log Exported Successfully!");
        this.setState({
          isExportModalVisible: false,
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  isValidExportDateRange = (startDate, endDate, showMessage = false) => {
    if (!startDate || !endDate) {
      return false;
    }

    const startDateObj = new Date(startDate);
    const endDateObj = new Date(endDate);

    if (startDateObj > endDateObj) {
      return false;
    }
    const timeDifference = endDateObj.getTime() - startDateObj.getTime();
    const daysDifference = timeDifference / (1000 * 3600 * 24);

    if (daysDifference <= 31) {
      return true;
    }

    if (showMessage) {
      message.warn("Date range cannot be more than 31 days");
    }

    return false;
  };

  render() {
    const {
      logs,
      exportType,
      isExportModalVisible,
      isLoading,
      filterDateTimeStart,
      filterDateTimeEnd,
      filterCardUID,
      filterUserName,
      filterGateIds,
      filterAccessTypeIds,
      gates,
      accessTypes,
      exportDateStart,
      exportDateEnd,
    } = this.state;
    const { currentLang } = this.props;
    return (
      <div className="site-feature-container">
        <div className="page-header-container">
          <div>
            <div className="page-header-main">Report </div>
            <div className="page-header-sub">Card Log</div>
          </div>
        </div>
        <Card bodyStyle={flexColumn} style={flexColumnOverflow}>
          <Spin tip="Please Wait..." spinning={isLoading}>
            <Row
              style={{ margin: 0 }}
              className="visitor-history-search-wrapper"
            >
              <Col
                flex="900px"
                className="visitor-detail-group"
                style={{ padding: "0px" }}
              >
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input.Group
                      compact
                      className="group-compact-select-wrapper"
                    >
                      <span className="ant-input-group-addon group-addon-label">
                        Date
                      </span>
                      <DatePicker
                        style={{ width: "100%" }}
                        showToday={false}
                        placeholder="Start"
                        format="DD/MM/YYYY HH:mm"
                        value={filterDateTimeStart}
                        showTime={true}
                        onChange={(evt) => {
                          let newfilterDateTimeEnd =
                            filterDateTimeEnd < evt
                              ? undefined
                              : filterDateTimeEnd;
                          this.setState({
                            logs: [],
                            filterDateTimeStart: evt,
                            filterDateTimeEnd: newfilterDateTimeEnd,
                          });
                        }}
                      />
                    </Input.Group>
                  </Col>
                  <Col style={{ width: "5px" }} />
                  <Col span={10}>
                    <DatePicker
                      style={{ width: "100%" }}
                      showToday={false}
                      value={filterDateTimeEnd}
                      placeholder="End"
                      format="DD/MM/YYYY HH:mm"
                      showTime={true}
                      onChange={(evt) => {
                        let newfilterDateTimeStart =
                          filterDateTimeStart > evt
                            ? undefined
                            : filterDateTimeStart;
                        this.setState({
                          logs: [],
                          filterDateTimeStart: newfilterDateTimeStart,
                          filterDateTimeEnd: evt,
                        });
                      }}
                      ƒ
                    />
                  </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input
                      addonBefore="Card"
                      placeholder="UID"
                      type="number"
                      name="filterCardUID"
                      value={filterCardUID}
                      onChange={this.onInputFieldChange}
                    />
                  </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input.Group
                      compact
                      className="group-compact-select-wrapper"
                    >
                      <span className="ant-input-group-addon group-addon-label">
                        Access Type
                      </span>
                      <Select
                        placeholder="Type"
                        className="group-addon-input"
                        value={filterAccessTypeIds}
                        onChange={(val) =>
                          this.setState({
                            logs: [],
                            filterAccessTypeIds: val,
                          })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        mode="multiple"
                        style={{ width: "100%" }}
                        maxTagCount="responsive"
                      >
                        {accessTypes.map((at) => {
                          return (
                            <Option key={at.id} value={at.id}>
                              {at.display_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </Input.Group>
                  </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input.Group
                      compact
                      className="group-compact-select-wrapper"
                    >
                      <span className="ant-input-group-addon group-addon-label">
                        Gate
                      </span>
                      <Select
                        placeholder="IN/OUT"
                        className="group-addon-input"
                        value={filterGateIds}
                        onChange={(val) =>
                          this.setState({
                            logs: [],
                            filterGateIds: val,
                          })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        mode="multiple"
                        style={{ width: "100%" }}
                        maxTagCount="responsive"
                      >
                        {gates.map((gt) => {
                          return (
                            <Option key={gt.id} value={gt.id}>
                              {gt.display_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </Input.Group>
                  </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input
                      addonBefore="Processed By"
                      placeholder="Username"
                      name="filterUserName"
                      value={filterUserName}
                      onChange={this.onInputFieldChange}
                    />
                  </Col>
                </Row>
                <div className="visitor-action-group">
                  <Button
                    type="primary"
                    style={{ marginRight: "15px", width: "120px" }}
                    disabled={isLoading}
                    onClick={this.onSearchClick}
                  >
                    {locale.app.common.search[currentLang]}
                  </Button>
                  <Button
                    style={{ marginRight: "15px", width: "120px" }}
                    disabled={!this.isFiltered()}
                    onClick={this.onClearClick}
                  >
                    {locale.app.common.reset[currentLang]}
                  </Button>
                  <Button
                    style={{ marginRight: "15px", width: "120px" }}
                    onClick={() => {
                      this.setState({
                        isExportModalVisible: true,
                        exportType: null,
                        exportDateStart: null,
                        exportDateEnd: null,
                      });
                    }}
                  >
                    {locale.app.common.export[currentLang]}
                  </Button>
                </div>
              </Col>
            </Row>
            <Row style={{ margin: 0 }}>
              <div className="table-section-header">Card Log</div>
              <Table
                rowKey="id"
                style={{ overflow: "auto", width: "100%" }}
                columns={columns}
                dataSource={logs}
                size="small"
                scroll={{ x: "max-content" }}
              />
            </Row>
          </Spin>
        </Card>
        <Modal
          title={"Export Card Log"}
          closable={false}
          visible={isExportModalVisible}
          onOk={() => {
            if (exportType) {
              this.getReport(exportType);
            }
          }}
          onCancel={() => {
            this.setState({
              isExportModalVisible: false,
            });
          }}
          okButtonProps={{
            disabled:
              !exportType ||
              isLoading ||
              !exportDateStart ||
              !exportDateEnd ||
              !this.isValidExportDateRange(exportDateStart, exportDateEnd),
          }}
          cancelButtonProps={{ disabled: isLoading }}
        >
          <Form
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
          >
            <Form.Item
              label="Start Date Time"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showToday={false}
                showTime={true}
                placeholder=" "
                format="DD/MM/YYYY HH:mm"
                value={exportDateStart}
                onChange={(evt) => {
                  this.isValidExportDateRange(evt, exportDateEnd, true);
                  this.setState({
                    exportDateStart: evt,
                  });
                }}
              />
            </Form.Item>
            <Form.Item
              label="End Date Time"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showToday={false}
                showTime={true}
                placeholder=" "
                format="DD/MM/YYYY HH:mm"
                value={exportDateEnd}
                onChange={(evt) => {
                  this.isValidExportDateRange(exportDateStart, evt, true);
                  this.setState({
                    exportDateEnd: evt,
                  });
                }}
              />
            </Form.Item>
            <Form.Item
              label="Format"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Radio.Group
                options={options}
                onChange={(e) => {
                  this.setState({
                    exportType: e.target.value,
                  });
                }}
                value={exportType}
              />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}
